// The one-shot probe of the tenant feature `map` (#169, src/core/mapFeature.ts):
// the cheapest map root — an event that cannot exist answers null when the
// feature is on and FEATURE_DISABLED when it is off.
import { graphql } from 'src/graphql'

export const MapFeatureProbeDocument = graphql(/* GraphQL */ `
  query MapFeatureProbe {
    eventMap(eventId: "0") {
      id
    }
  }
`)
